module.exports = __webpack_public_path__ + "assets/img/37_1628.ed44d2bb.jpg";